import { ResponseWrapper } from './response-wrapper';

export class DataResponseWrapper<T> extends ResponseWrapper {
    constructor(success: boolean, message: string, data: T) {
        super(success, message);
        this.data = data;
    }
    data: T;
}
